/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_PaidInputs */

const vi_order_payment_paid = /** @type {(inputs: Order_Payment_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thanh toán`)
};

/**

* @param {Order_Payment_PaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_paid = /** @type {((inputs?: Order_Payment_PaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_PaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_paid(inputs)
});